import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import './Appointment.css';

import { useTheme } from '@emotion/react';
import { Add, Delete, Edit } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import {
    AppBar,
    Badge,
    Chip,
    CircularProgress,
    Dialog,
    DialogContent,
    Divider,
    Menu,
    MenuItem,
    Modal,
    Stack,
    TextareaAutosize,
    Toolbar,
    capitalize,
    useMediaQuery,
} from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { resolveAppointmentWorkOrderRoute } from '../../services/business/workOrders';
import { toast } from 'sonner';
import CommonDialog from '../../common/CommonDialog.jsx';
import ReviewRequestModal from '../../common/ReviewRequestModal.jsx';
import { FormatNumberForKm } from '../../components/FormatNumber/FormatNumber';
import { configDetails } from '../../redux/Account/action.js';
import { addServiceToAppointmentDetailApi, deleteServiceFromAppointmentDetailApi, updateAppointmentStatus } from '../../redux/appointment/action';
import { appointmentKeys, useUpdateAppointmentNote } from '../../services/business/appointment';
import { useGetShopConfig } from '../../services/core/settings/settings.hooks.js';
import { SHOP_SERVICE_PRICE_TYPES, USER_CREATED_FROM, USER_TIMEZONE } from '../../utility/Constant.js';
import { eitherDisplayOrRemove, formatCurrency } from '../../utility/helpers/displayHelper.js';
import GuestCustomerInfoModal from '../Customers/GuestCustomers/GuestCustomerInfoModal.jsx';
import SaveCustomerConfirmModal from '../Customers/GuestCustomers/SaveCustomerConfirmModal.jsx';
import CancelAppointment from '../modal/CancelAppointment.jsx';
import ReseduleAppointmentModal from '../modal/ReseduleAppointmentModal.jsx';
import ShortServiceModal from '../Sidebar/ShortServiceModal.jsx';
import AddAssigneeModal from './TodayAppointment/AddAssigneeModal.jsx';

dayjs.extend(utc);
dayjs.extend(timezone);

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',

    boxShadow: 24,
};
const styleTag = {
    borderRadius: '48px',
    color: 'black',
    padding: '10px 20px',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    margin: '10px',
    width: '200px',
};
const serviceStyle = {
    fontSize: '13px',
    fontWeight: 500,
    // borderStyle: "solid",
    // borderWidth: "1px",
    // borderColor: "black",
    padding: '5px 10px',
    borderRadius: '20px',
    // color: "white",
};
function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
            {value === index && (
                <Box>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
const AppointmentModel = ({
    fromCaledner = false,
    open,
    handleClose,
    data,
    fetchAppointmentDetails,
    status,
    show,
    handleStatusClose,
    handleStatus,
    recallDetailsAPI,
    setAppointmentDropOffODo,
    setAppointmentCompletionOffODo,
    columns,
    setUpdateStatus,
    setSelectId,
    fetchCalendarDataonAppointmentStatusChange,
}) => {
    console.log('🚀 ~ AppointmentModel ~ data:', data);
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    const [value, setValue] = React.useState(0);
    // const [updateStatus, setUpdateStatus] = React.useState("");
    const [openRescheduleModal, setOpenRescheduleModal] = useState(false);
    const [openCancelModal, setOpenCancelModal] = useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [showLoader, setShowLoader] = React.useState(false);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [showAssignee, setShowAssignee] = useState(false);
    const [isAssignChanged, setIsAssigneeChanged] = useState(false);
    const [showMore, setShowMore] = useState(false);

    const [showReviewModal, setShowReviewModal] = useState(false);
    const [userReviewModalData, setUserReviewModalData] = useState('');
    const [reviewModalLastSentOn, setReviewModalLastSentOn] = useState('');

    const [openGuestModal, setOpenGuestModal] = useState(false);
    const [saveConfirmModal, setSaveConfirmModal] = useState(false);

    const [actionState, setActionState] = useState({
        isActionSaved: false, // Indicates if an action is saved
        messageToSend: null, // Holds a string message to send
        requestApproval: null, // Holds a function to handle rescheduling
        authRequest: null, // Holds a string for authentication requests
    });

    //new appointment hooks
    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
    const [isAddServiceModalOpen, setIsAddServiceModalOpen] = useState(false);
    const [selectedServiceId, setSelectedServiceId] = useState(null);
    const [isServiceLoader, setIsServiceLoader] = useState(false);
    const [appointmentServices, setAppointmentServices] = useState(data?.services || []);

    // Internal Shop Note edit state
    const [isEditingNote, setIsEditingNote] = useState(false);
    const [editedNote, setEditedNote] = useState('');
    const textareaRef = useRef(null);
    const [localNote, setLocalNote] = useState('');

    const { data: shopConfigData, isLoading: isConfigLoading, error: configError } = useGetShopConfig();

    useEffect(() => {
        if (data && data?.noteForCustomer) {
            setLocalNote(data?.noteForCustomer);
        }

        return () => {
            setLocalNote('');
        };
    }, [open, editedNote, data?.noteForCustomer]);

    // TanStack mutation for updating internal shop note
    const updateNoteMutation = useUpdateAppointmentNote();

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const handleClose1 = () => {
        setAnchorEl(null);
    };

    const handleCloseCancelModal = () => {
        setOpenCancelModal(false);
    };

    const handleOpenCancelModal = () => {
        setOpenCancelModal(true);
    };

    // Internal Shop Note handlers
    const handleEditNote = () => {
        setEditedNote(data?.noteForCustomer || '');
        setLocalNote(data?.noteForCustomer || '');
        setIsEditingNote(true);

        if (textareaRef.current) {
            textareaRef.current.focus();
            const length = textareaRef.current.value.length;
            textareaRef.current.setSelectionRange(length, length);
        }
    };

    const handleCancelEdit = () => {
        setEditedNote('');
        setIsEditingNote(false);
    };

    const handleSaveNote = async () => {
        if (!data?._id) return;

        try {
            await updateNoteMutation.mutateAsync({
                id: data._id,
                payload: {
                    noteForCustomer: editedNote,
                },
            });
            setLocalNote(editedNote);
            // Ensure latest data is pulled in, if helper is provided
            if (recallDetailsAPI) {
                await recallDetailsAPI();
            }
        } catch (error) {
            console.error('Error saving note:', error);
        } finally {
            await handleCancelEdit();
        }
    };
    const open1 = Boolean(anchorEl);
    const handlePreviewPdf = () => {
        const pdfUrl = data?.estimate?.pdfUrl;
        window.open(pdfUrl, '_blank');
    };
    const handleClick1 = (event) => {
        setAnchorEl(event.currentTarget);
        if (setSelectId) setSelectId(data?._id);
    };
    const filteredData = data?.services?.filter((item) => item.newAdded);

    useEffect(() => {
        if (open) {
            fetchConfig();
        }
    }, [open]);

    const fetchConfig = async () => {
        await dispatch(configDetails());
    };

    const SHOP_NAME = useMemo(() => {
        try {
            return JSON.parse(localStorage.getItem('apex-saas_details'))?.shopName || '';
        } catch (e) {
            return '';
        }
    }, []);

    const appointmentReviewManualSelect = useSelector((state) => state.account.configDetailData);

    const platform = appointmentReviewManualSelect?.appointmentReviewPlatform;

    const modalTitle = platform === 'google' ? 'Send a Google review request?' : 'Send a review request?';

    const showInstructionText =
        platform === 'google'
            ? 'Grow your online reputation by requesting a Google review. Skip if they have already left a review or if you want to follow-up privately.'
            : platform === 'apex_auto'
              ? 'The customer will be prompted to leave the review on the Apex Auto filtration system. 4+ star reviews will be prompted to also leave a review on Google.'
              : 'Default instruction for other platforms.';

    const googleImage = platform === 'google';

    filteredData?.map((item) => {
        if (item?.pricingType == 'labor_&_parts') {
            item.sumTotalAmount = item?.parts?.reduce((accumulator, object) => {
                return accumulator + parseFloat(object?.totalAmount);
            }, 0);
        }
    });

    const path = window.location.pathname.split('/');

    const UpdateStatus = async (id, status, queryString, customMessage) => {
        setShowLoader(true);
        const payload = { status, ...(customMessage && { customMessage }) };
        const fullUrl = `${id}${queryString ? `?${queryString}` : ''}`;
        const statusUpdate = await dispatch(updateAppointmentStatus(fullUrl, payload));
        if (statusUpdate) {
            handleClose();
            // navigate("/appointment/today");
        }
        setShowLoader(false);
        if (path.includes('calendar')) {
            fetchCalendarDataonAppointmentStatusChange();
        }
        if (path.includes('workOrderAuthorization')) {
            recallDetailsAPI();
        }
    };

    const handleCloseAssigneeModal = () => {
        setShowAssignee(false);
    };
    useEffect(() => {
        if (isAssignChanged) {
            if (recallDetailsAPI) {
                recallDetailsAPI();
                if (path.includes('calendar')) {
                    fetchCalendarDataonAppointmentStatusChange();
                }
            }
            setIsAssigneeChanged(false);
        }
    }, [isAssignChanged]);

    useEffect(() => {
        if (!open) {
            setValue(0);
            setAppointmentServices([]);
        } else {
            setAppointmentServices(data?.services || []);
        }
    }, [open, data]);

    return (
        <Box>
            <Modal
                open={open}
                onClose={() => {
                    handleClose();
                    setEditedNote('');
                    setIsEditingNote(false);
                    setLocalNote('');
                }}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
            >
                <Box sx={{ ...style, width: '896px', border: 'none' }} className="appointmentModalBodyBoxContainer">
                    <AppBar
                        variant="outlined"
                        className="modalHeader"
                        sx={{
                            height: '64px',
                            paddingRight: '0px !important',
                        }}
                    >
                        <Toolbar variant="regular">
                            <Typography variant="h6" gutterBottom={false} style={{ color: 'rgba(0, 0, 0, 0.87' }} width={'98%'} fontSize={'20px'}>
                                Appointment Details
                            </Typography>
                            <Stack direction={'row'} spacing={0}>
                                <div
                                    onClick={() => {
                                        handleClose();
                                        setEditedNote('');
                                        setIsEditingNote(false);
                                        setLocalNote('');
                                    }}
                                    className="appointmentModal"
                                    style={{ cursor: 'pointer', height: '32px', color: 'black' }}
                                >
                                    <CloseIcon style={{ fontSize: 32, fill: 'rgb(0 0 0 / 56%)' }} />
                                </div>
                            </Stack>
                        </Toolbar>
                    </AppBar>
                    <Grid container marginTop={'64px'} fontSize={'15px'} minHeight={'608px'} fontWeight={500} className="modalBody_container">
                        <Grid
                            item
                            md={4.13}
                            sm={12}
                            xs={12}
                            padding={'24px'}
                            style={{ background: '#F5F5F7' }}
                            borderRight={'1px solid rgba(0, 0, 0, 0.23)'}
                            className="appointmentModal_leftContainer"
                            gap={2}
                        >
                            <Stack gap={'16px'}>
                                <div>
                                    <Button
                                        variant="contained"
                                        fullWidth
                                        endIcon={<KeyboardArrowDownIcon />}
                                        style={{
                                            backgroundColor:
                                                status == 'waiting_for_drop_off'
                                                    ? '#75DBFF'
                                                    : status == 'vehicle_dropped_off'
                                                      ? '#FFC30F'
                                                      : status == 'in_progress'
                                                        ? '#FF9E31'
                                                        : status == 'ready_for_pick_up'
                                                          ? '#5CE469'
                                                          : status == 'customer_paid'
                                                            ? '#00CD44'
                                                            : '#F44336',
                                            //   : "#5CE469",
                                            borderRadius: '48px',
                                            color: 'black',
                                            padding: '6px 16px',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        }}
                                        aria-controls={open1 ? 'demo-positioned-menu' : undefined}
                                        aria-haspopup="true"
                                        aria-expanded={open1 ? 'true' : undefined}
                                        onClick={handleClick1}
                                    >
                                        {status == 'waiting_for_drop_off' && 'Waiting for drop off'}
                                        {status == 'vehicle_dropped_off' && 'VEHICLE DROPPED OFF'} {status == 'in_progress' && 'IN PROGRESS'}{' '}
                                        {status == 'customer_paid' && 'CUSTOMER PAID'} {status == 'mark_as_no_show' && 'MARK AS NO SHOW'}
                                        {status == 'ready_for_pick_up' && 'READY FOR PICKUP'}
                                    </Button>

                                    <Menu
                                        style={{ width: '400px' }}
                                        id="demo-positioned-menu"
                                        aria-labelledby="demo-positioned-button"
                                        anchorEl={anchorEl}
                                        open={open1}
                                        onClose={handleClose1}
                                        anchorOrigin={{
                                            vertical: 'top',
                                            horizontal: 'left',
                                        }}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'left',
                                        }}
                                    >
                                        <MenuItem>Update Status</MenuItem>
                                        <MenuItem
                                            onClick={() => {
                                                setUpdateStatus('waiting_for_drop_off');
                                                // handleStatus();
                                                UpdateStatus(data?._id, 'waiting_for_drop_off');
                                                handleClose1();
                                            }}
                                            // disabled={true}
                                            style={{ ...styleTag, backgroundColor: '#75DBFF' }}
                                        >
                                            Waiting for Drop Off
                                        </MenuItem>

                                        <MenuItem
                                            onClick={() => {
                                                handleClose1();

                                                setUpdateStatus('vehicle_dropped_off');
                                                UpdateStatus(data?._id, 'vehicle_dropped_off');
                                                // if (status == "waiting_for_drop_off") {
                                                //   handleStatus();
                                                // } else {
                                                //   UpdateStatus(data?._id, "vehicle_dropped_off");
                                                // }
                                            }}
                                            // disabled={
                                            //   status == "waiting_for_drop_off" ||
                                            //   status == "in_progress"
                                            //     ? false
                                            //     : true
                                            // }
                                            style={{
                                                ...styleTag,
                                                background: '#FFC30F',
                                            }}
                                        >
                                            Vehicle Dropped Off
                                        </MenuItem>
                                        <MenuItem
                                            onClick={() => {
                                                handleClose1();

                                                setUpdateStatus('in_progress');
                                                UpdateStatus(data?._id, 'in_progress');
                                                // if (status == "waiting_for_drop_off") {
                                                //   handleStatus();
                                                // } else {
                                                //   UpdateStatus(data?._id, "in_progress");
                                                // }
                                            }}
                                            // disabled={
                                            //   status == "waiting_for_drop_off" ||
                                            //   status == "vehicle_dropped_off" ||
                                            //   status == "ready_for_pick_up"
                                            //     ? false
                                            //     : true
                                            // }
                                            style={{
                                                ...styleTag,
                                                background: '#FF9E31',
                                            }}
                                        >
                                            In Progress
                                        </MenuItem>
                                        <MenuItem
                                            onClick={() => {
                                                handleClose1();

                                                setUpdateStatus('ready_for_pick_up');
                                                setAppointmentDropOffODo(null);
                                                setAppointmentCompletionOffODo(null);

                                                if (window.location.pathname.includes('calendar')) {
                                                    if (data?.dropOffODO) setAppointmentDropOffODo(data?.dropOffODO);

                                                    if (data?.completionODO) setAppointmentCompletionOffODo(data?.completionODO);
                                                } else {
                                                    let found = columns?.[status]?.items?.filter((d) => d._id == data?._id);

                                                    if (Array.isArray(found) && found?.[0]?.dropOffODO) {
                                                        setAppointmentDropOffODo(found?.[0]?.dropOffODO);
                                                    }
                                                    if (Array.isArray(found) && found?.[0]?.completionODO) {
                                                        setAppointmentCompletionOffODo(found?.[0]?.completionODO);
                                                    }
                                                }
                                                // if (
                                                //   status == "waiting_for_drop_off" ||
                                                //   status == "vehicle_dropped_off" ||
                                                //   status == "in_progress"
                                                // ) {
                                                //   handleStatus();
                                                // } else {
                                                //   UpdateStatus(data?._id, "ready_for_pick_up");
                                                // }
                                                UpdateStatus(data?._id, 'ready_for_pick_up');
                                            }}
                                            // disabled={
                                            //   status == "waiting_for_drop_off" ||
                                            //   status == "vehicle_dropped_off" ||
                                            //   status == "in_progress"
                                            //     ? false
                                            //     : true
                                            // }
                                            style={{
                                                ...styleTag,
                                                background: '#5CE469',
                                            }}
                                        >
                                            Ready for Pick Up
                                        </MenuItem>
                                        <MenuItem
                                            onClick={() => {
                                                // Reset ODOs
                                                setAppointmentDropOffODo(null);
                                                setAppointmentCompletionOffODo(null);

                                                const found = columns?.[status]?.items?.filter((d) => d._id == data?._id);

                                                if (Array.isArray(found) && found[0]?.dropOffODO) {
                                                    setAppointmentDropOffODo(found[0].dropOffODO);
                                                }
                                                if (Array.isArray(found) && found[0]?.completionODO) {
                                                    setAppointmentCompletionOffODo(found[0].completionODO);
                                                }

                                                if (!appointmentReviewManualSelect?.appointmentReviewManualSelect) {
                                                    handleClose1();
                                                    setUpdateStatus('customer_paid');
                                                    setAppointmentDropOffODo(null);
                                                    setAppointmentCompletionOffODo(null);
                                                    if (window.location.pathname.includes('calendar')) {
                                                        if (data?.dropOffODO) setAppointmentDropOffODo(data?.dropOffODO);
                                                        if (data?.completionODO) setAppointmentCompletionOffODo(data?.completionODO);
                                                    } else {
                                                        let foundCol = columns?.[status]?.items?.filter((d) => d._id == data?._id);
                                                        if (Array.isArray(foundCol) && foundCol?.[0]?.dropOffODO)
                                                            setAppointmentDropOffODo(foundCol?.[0]?.dropOffODO);
                                                        if (Array.isArray(foundCol) && foundCol?.[0]?.completionODO)
                                                            setAppointmentCompletionOffODo(foundCol?.[0]?.completionODO);
                                                    }
                                                    UpdateStatus(data?._id, 'customer_paid');
                                                } else if (data?.googleReviewRequest?.reviewCompleted === true) {
                                                    handleClose1();
                                                    setUpdateStatus('customer_paid');
                                                    setAppointmentDropOffODo(null);
                                                    setAppointmentCompletionOffODo(null);
                                                    if (window.location.pathname.includes('calendar')) {
                                                        if (data?.dropOffODO) setAppointmentDropOffODo(data?.dropOffODO);
                                                        if (data?.completionODO) setAppointmentCompletionOffODo(data?.completionODO);
                                                    } else {
                                                        let foundCol = columns?.[status]?.items?.filter((d) => d._id == data?._id);
                                                        if (Array.isArray(foundCol) && foundCol?.[0]?.dropOffODO)
                                                            setAppointmentDropOffODo(foundCol?.[0]?.dropOffODO);
                                                        if (Array.isArray(foundCol) && foundCol?.[0]?.completionODO)
                                                            setAppointmentCompletionOffODo(foundCol?.[0]?.completionODO);
                                                    }
                                                    UpdateStatus(data?._id, 'customer_paid');
                                                } else {
                                                    setSelectId(data?._id);
                                                    handleClose1();
                                                    const list = Array.isArray(found?.[0]?.previousGoogleReviewRequests)
                                                        ? found[0].previousGoogleReviewRequests
                                                        : [];
                                                    const latestGroup = list.length > 0 ? list[0] : null;
                                                    const lastSentAt = latestGroup?.lastSentAt;
                                                    const rr = Array.isArray(latestGroup?.reviewRequest) ? latestGroup.reviewRequest : [];
                                                    const lastReq = rr.length > 0 ? rr[rr.length - 1] : null;

                                                    const isWithin24Hours =
                                                        lastSentAt &&
                                                        dayjs(lastSentAt).tz(USER_TIMEZONE).isAfter(dayjs().tz(USER_TIMEZONE).subtract(24, 'hours'));

                                                    let lastSentOnMessage = '';

                                                    if (!latestGroup || list.length === 0 || !lastSentAt || rr.length === 0 || !lastReq) {
                                                        lastSentOnMessage = '';
                                                    } else {
                                                        const channels = [];

                                                        if (lastReq?.sms?.sent) channels.push('text');
                                                        if (lastReq?.email?.sent) channels.push('email');
                                                        if (lastReq?.notification?.sent) channels.push('app');

                                                        let channelsLabel = '—';
                                                        if (channels.length === 1) {
                                                            channelsLabel = channels[0];
                                                        } else if (channels.length === 2) {
                                                            channelsLabel = `${channels[0]} and ${channels[1]}`;
                                                        } else if (channels.length >= 3) {
                                                            channelsLabel = `${channels[0]}, ${channels[1]} and ${channels[2]}`;
                                                        }

                                                        const formattedDate = dayjs(lastSentAt).tz(USER_TIMEZONE).format('DD-MMMM-YYYY');

                                                        if (isWithin24Hours) {
                                                            lastSentOnMessage = `Last sent via ${channelsLabel} today`;
                                                        } else if (list.length === 1) {
                                                            lastSentOnMessage = `Last sent via ${channelsLabel} on ${formattedDate}`;
                                                        } else {
                                                            lastSentOnMessage = `${list.length} review requests sent previously. Last sent via ${channelsLabel} on ${formattedDate}`;
                                                        }
                                                    }

                                                    setReviewModalLastSentOn(lastSentOnMessage);
                                                    setUserReviewModalData(found);
                                                    setShowReviewModal(true);
                                                }
                                            }}
                                            // disabled={
                                            //   status == "waiting_for_drop_off" ||
                                            //   status == "vehicle_dropped_off" ||
                                            //   status == "in_progress" ||
                                            //   status == "ready_for_pick_up"
                                            //     ? false
                                            //     : true
                                            // }
                                            style={{
                                                ...styleTag,
                                                background: '#00CD44',
                                            }}
                                        >
                                            Customer Paid
                                        </MenuItem>
                                        <MenuItem
                                            onClick={() => {
                                                handleClose1();
                                                setUpdateStatus('mark_as_no_show');
                                                UpdateStatus(data?._id, 'mark_as_no_show');
                                            }}
                                            // disabled={status == "waiting_for_drop_off" ? false : true}
                                            style={{
                                                ...styleTag,
                                                background: '#F44336',
                                            }}
                                        >
                                            Mark as No Show
                                        </MenuItem>
                                    </Menu>
                                </div>
                                {/* <AddOdoModal open={show} handleClose={handleStatusClose} status={updateStatus} id={data?._id} handleClose1={handleClose1} /> */}

                                {data?.hasEstimate && (
                                    <Button
                                        variant="contained"
                                        size="large"
                                        fullWidth
                                        sx={{
                                            height: '42px',
                                            lineHeight: '26px',
                                            letterSpacing: '0.46px',
                                            fontSize: '15px',
                                        }}
                                        onClick={handlePreviewPdf}
                                    >
                                        VIEW ESTIMATE
                                    </Button>
                                )}
                                <Button
                                    variant="contained"
                                    size="large"
                                    fullWidth
                                    // onClick={() => navigate(`/messenger/${data?.customer?._id}`)}

                                    onClick={() => {
                                        if (data?.customer?.createdFrom === USER_CREATED_FROM.SHOP_GUEST) {
                                            setSaveConfirmModal(true);
                                            setActionState({
                                                isActionSaved: true,
                                                messageToSend: `/messenger/${data?.customer?._id}`,
                                                requestApproval: null,
                                                authRequest: null,
                                            });
                                        } else {
                                            navigate(`/messenger/${data?.customer?._id}`);
                                        }
                                    }}
                                >
                                    SEND MESSAGE
                                </Button>

                                {/* Create  / View Invoice Button */}

                                <Button
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    sx={{
                                        height: '42px',
                                        lineHeight: '26px',
                                        letterSpacing: '0.46px',
                                        fontSize: '15px',
                                    }}
                                    onClick={() => {
                                        if (data?.invoice?._id) {
                                            const { _id, status, isEmailSent } = data.invoice;

                                            let routeStatus;

                                            if (status === 'draft') {
                                                routeStatus = 'draft';
                                            } else if (status === 'sent') {
                                                routeStatus = isEmailSent ? 'sent' : 'finalized';
                                            } else {
                                                routeStatus = status;
                                            }

                                            navigate(`/invoice/${routeStatus}/${_id}`);
                                        } else {
                                            navigate(`/invoice/new/${data?._id}`);
                                        }
                                    }}
                                >
                                    {data?.invoice?._id ? 'VIEW INVOICE' : 'CREATE INVOICE'}
                                </Button>

                                {status === 'waiting_for_drop_off' && (
                                    <Button
                                        variant="contained"
                                        fullWidth
                                        sx={{
                                            height: '42px',
                                            lineHeight: '26px',
                                            letterSpacing: '0.46px',
                                            fontSize: '15px',
                                        }}
                                        onClick={() => {
                                            if (data?.customer?.createdFrom === USER_CREATED_FROM.SHOP_GUEST) {
                                                setSaveConfirmModal(true);
                                                setActionState({
                                                    isActionSaved: true,
                                                    messageToSend: null,
                                                    rescheduleAction: true,
                                                    authRequest: null,
                                                });
                                            } else {
                                                setOpenRescheduleModal(true);
                                            }
                                        }}
                                    >
                                        reschedule
                                    </Button>
                                )}
                            </Stack>

                            <Stack gap={'16px'}>
                                <Button
                                    variant="contained"
                                    size="large"
                                    color="greyColor"
                                    sx={{
                                        height: '42px',
                                        lineHeight: '26px',
                                        letterSpacing: '0.46px',
                                        fontSize: '15px',
                                        width: '100%',
                                        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.25)',
                                    }}
                                    onClick={() => {
                                        if (data?.customer?.createdFrom === USER_CREATED_FROM.SHOP_GUEST) {
                                            setSaveConfirmModal(true);
                                            setActionState({
                                                isActionSaved: true,
                                                messageToSend: null,
                                                requestApproval: `/appointment/newApproval/${data?._id}`,
                                                authRequest: null,
                                            });
                                        } else {
                                            navigate(`/appointment/newApproval/${data?._id}`);
                                        }
                                    }}
                                >
                                    REQUEST APPROVAL
                                </Button>
                                {!location.pathname.split('/').includes('workOrderAuthorization') && (
                                    <Badge invisible={data?.workOrderAuthorization?.showUnreadBadge == true ? false : true} badgeContent={''} color="error">
                                        <Button
                                            variant="contained"
                                            size="large"
                                            color="greyColor"
                                            fullWidth
                                            sx={{
                                                height: '42px',
                                                lineHeight: '26px',
                                                letterSpacing: '0.46px',
                                                fontSize: '15px',
                                                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.25)',
                                            }}
                                            // onClick={() =>
                                            // navigate(
                                            //   `/appointment/workOrderAuthorization/${data?._id}`
                                            // )
                                            // }
                                            onClick={() => {
                                                // Opens the existing work order, or the new work order editor
                                                // prefilled from this appointment (spec §6.3).
                                                const workOrderRoute = resolveAppointmentWorkOrderRoute(data);

                                                if (data?.customer?.createdFrom === USER_CREATED_FROM.SHOP_GUEST) {
                                                    setSaveConfirmModal(true);
                                                    setActionState({
                                                        isActionSaved: true,
                                                        messageToSend: null,
                                                        requestApproval: null,
                                                        authRequest: workOrderRoute,
                                                    });
                                                } else {
                                                    navigate(workOrderRoute);
                                                }
                                            }}
                                        >
                                            {data?.workOrderAuthorization?._id ? 'VIEW AUTHORIZATION' : 'REQUEST AUTHORIZATION'}
                                        </Button>
                                    </Badge>
                                )}

                                {status === 'waiting_for_drop_off' && (
                                    <Button
                                        variant="contained"
                                        color="error"
                                        fullWidth
                                        sx={{
                                            height: '42px',
                                            lineHeight: '26px',
                                            letterSpacing: '0.46px',
                                            fontSize: '15px',
                                        }}
                                        onClick={handleOpenCancelModal}
                                    >
                                        Cancel
                                    </Button>
                                )}
                            </Stack>
                        </Grid>
                        {/* <Divider orientation="vertical" flexItem /> */}
                        <Grid item md={7.8} sm={12} xs={12} padding={'24px'} className="appointmentModal_rightContainer">
                            <Box sx={{ width: '100%', border: '1px' }}>
                                <Box marginBottom={'24px'}>
                                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                                        <Tab style={{ fontSize: '14px' }} label="OVERVIEW" {...a11yProps(0)} />

                                        <Tab style={{ fontSize: '14px' }} label="VEHICLE" {...a11yProps(1)} />
                                        <Tab style={{ fontSize: '14px' }} label="SERVICES" {...a11yProps(2)} />
                                    </Tabs>
                                </Box>
                                <CustomTabPanel value={value} index={0}>
                                    <Grid container item spacing={2}>
                                        <Grid container item>
                                            <Grid item md={4} sm={4} xs={4} fontSize={'14px'} color={'#00000099'} lineHeight={'143%'} letterSpacing={'0.17px'}>
                                                Customer
                                            </Grid>

                                            {data?.customer?.createdFrom === USER_CREATED_FROM.SHOP_GUEST ? (
                                                <span
                                                    onClick={() => setOpenGuestModal(true)}
                                                    style={{
                                                        color: '#2196F3',
                                                        textDecoration: 'none',
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    {data?.customer?.firstName} {data?.customer?.lastName || ''}
                                                </span>
                                            ) : (
                                                <Link
                                                    to={`/customers/${data?.customer?._id}/${data?.customer?.createdFrom}`}
                                                    style={{ color: '#2196F3', textDecoration: 'none' }}
                                                >
                                                    {data?.customer?.firstName} {data?.customer?.lastName || ''}
                                                </Link>
                                            )}
                                        </Grid>
                                        <Grid container item>
                                            <Grid item xs={4} fontSize={'14px'} color={'#00000099'} lineHeight={'143%'} letterSpacing={'0.17px'}>
                                                Vehicle
                                            </Grid>
                                            <Grid item md={8} fontSize={'16px'} color={'#000000'}>
                                                {eitherDisplayOrRemove(data?.vehicle?.year) +
                                                    ' ' +
                                                    eitherDisplayOrRemove(data?.vehicle?.vehicleMake?.name) +
                                                    ' ' +
                                                    eitherDisplayOrRemove(data?.vehicle?.vehicleModel?.name)}{' '}
                                            </Grid>
                                        </Grid>
                                        <Grid container item>
                                            <Grid item xs={4} fontSize={'14px'} color={'#00000099'} lineHeight={'143%'} letterSpacing={'0.17px'}>
                                                Drop Off
                                            </Grid>
                                            <Grid item md={8} fontSize={'16px'} color={'#000000'}>
                                                {data?.dropOffDateTime ? moment(data?.dropOffDateTime).format('MMM D, YYYY hh:mm A') : ' - '}
                                            </Grid>
                                        </Grid>
                                        {/* <Grid container item>
                                            <Grid item xs={4} fontSize={'14px'} color={'#00000099'} lineHeight={'143%'} letterSpacing={'0.17px'}>
                                                Estimated Pick Up
                                            </Grid>
                                            <Grid item md={8} color={'#2196F3'} fontSize={'16px'}>
                                                {data?.pickupDateTime
                                                    ? moment(data?.pickupDateTime).format('MMM D, YYYY hh:mm A')
                                                    : moment(data?.shopClosingTime).format('MMM D, YYYY hh:mm A')}
                                            </Grid>
                                        </Grid> */}
                                        <Grid container item>
                                            <Grid item xs={4} fontSize={'14px'} color={'#00000099'} lineHeight={'143%'} letterSpacing={'0.17px'}>
                                                Wait or Drop Off
                                            </Grid>
                                            <Grid item md={8} fontSize={'16px'} color={'#000000'}>
                                                {data?.waitingOnSite && data?.waitingOnSite == 'dropping_off_car' ? 'Dropping Off Car' : ' Wait on Site '}
                                            </Grid>
                                        </Grid>
                                        <Grid container item>
                                            <Grid item xs={4} fontSize={'14px'} color={'#00000099'} lineHeight={'143%'} letterSpacing={'0.17px'}>
                                                Contact Preferences
                                            </Grid>
                                            <Grid item md={8} fontSize={'16px'} color={'#000000'}>
                                                {/* {data?.contactPreferences ? data?.contactPreferences : " - "} */}
                                                {data?.contactPreferences && data?.contactPreferences == 'phone'
                                                    ? 'Phone Call'
                                                    : data?.contactPreferences == 'email'
                                                      ? 'Email'
                                                      : 'In-App Message'}
                                            </Grid>
                                        </Grid>

                                        <Grid container item>
                                            <Grid item xs={4} fontSize={'14px'} color={'#00000099'} lineHeight={'143%'} letterSpacing={'0.17px'}>
                                                Assigned To
                                            </Grid>
                                            {data?.assignee && Array.isArray(data?.assignee) ? (
                                                <Grid
                                                    item
                                                    md={8}
                                                    color={'#2196F3'}
                                                    fontSize={'16px'}
                                                    sx={{ cursor: 'pointer' }}
                                                    onClick={() => setShowAssignee(true)}
                                                    // border={"1px solid gray"}
                                                    // padding={"10px 10px"}
                                                    // borderRadius={"8px"}
                                                    // fontSize={"16px"}
                                                    // color={'#000000de'}
                                                >
                                                    {data?.assignee[0]?.name}
                                                </Grid>
                                            ) : (
                                                ' - '
                                            )}
                                            {/* Assigned */}
                                        </Grid>

                                        <Grid container item>
                                            <Grid item xs={4} fontSize={'14px'} color={'#00000099'} lineHeight={'143%'} letterSpacing={'0.17px'}>
                                                Note from Customer
                                            </Grid>
                                            {data?.noteForMechanic ? (
                                                <Grid
                                                    item
                                                    md={8}
                                                    border={'1px solid gray'}
                                                    padding={'10px 10px'}
                                                    borderRadius={'8px'}
                                                    fontSize={'16px'}
                                                    color={'#000000'}
                                                >
                                                    {data?.noteForMechanic}
                                                </Grid>
                                            ) : (
                                                ' - '
                                            )}
                                        </Grid>

                                        <Grid container item>
                                            <Grid item xs={4} fontSize={'14px'} color={'#00000099'} lineHeight={'143%'} letterSpacing={'0.17px'}>
                                                Internal Shop Note
                                            </Grid>
                                            <Grid item md={8}>
                                                {isEditingNote ? (
                                                    <Box>
                                                        <TextareaAutosize
                                                            ref={textareaRef}
                                                            value={editedNote}
                                                            onChange={(e) => {
                                                                setEditedNote(e.target.value);
                                                                setLocalNote(e.target.value);
                                                            }}
                                                            // placeholder="Enter internal shop note..."
                                                            style={{
                                                                width: '100%',
                                                                padding: '0',
                                                                maxHeight: '80px',
                                                                border: 'none',
                                                                outline: 'none',
                                                                fontSize: '16px',
                                                                fontFamily: 'inherit',
                                                                borderBottom: '1px solid #ccc',
                                                                paddingBottom: '2px',
                                                                resize: 'none',
                                                            }}
                                                        />
                                                        <Box sx={{ display: 'flex', gap: '10px', marginTop: '10px', justifyContent: 'flex-end' }}>
                                                            <Button
                                                                variant="outlined"
                                                                onClick={() => {
                                                                    setLocalNote(data?.noteForCustomer || '');
                                                                    handleCancelEdit();
                                                                }}
                                                                sx={{
                                                                    backgroundColor: '#EA43351A',
                                                                    color: '#D32F2F',
                                                                    border: 'none',
                                                                    boxShadow: 'none',
                                                                    borderRadius: '8px',
                                                                    '&:hover': {
                                                                        backgroundColor: '#EA43351A',
                                                                        color: '#D32F2F',
                                                                        border: 'none',
                                                                        boxShadow: 'none',
                                                                        borderRadius: '8px',
                                                                    },
                                                                }}
                                                            >
                                                                CANCEL
                                                            </Button>
                                                            <Button
                                                                variant="contained"
                                                                onClick={handleSaveNote}
                                                                sx={{
                                                                    backgroundColor: '#006CDD1A',
                                                                    color: '#006CDD',
                                                                    border: 'none',
                                                                    boxShadow: 'none',
                                                                    borderRadius: '8px',
                                                                    '&:hover': {
                                                                        backgroundColor: '#006CDD1A',
                                                                        border: 'none',
                                                                        color: '#006CDD',
                                                                        boxShadow: 'none',
                                                                        borderRadius: '8px',
                                                                    },
                                                                }}
                                                            >
                                                                SAVE
                                                            </Button>
                                                        </Box>
                                                    </Box>
                                                ) : (
                                                    <Stack direction="row" alignItems="center" gap={1}>
                                                        <Typography> {localNote || '-'} </Typography>
                                                        <Edit
                                                            sx={{
                                                                fontSize: '20px',
                                                                cursor: 'pointer',
                                                                color: '#646466',
                                                            }}
                                                            onClick={handleEditNote}
                                                        />
                                                    </Stack>
                                                )}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </CustomTabPanel>
                                <CustomTabPanel value={value} index={1}>
                                    <Grid container item spacing={2}>
                                        <Grid container item>
                                            <Grid item xs={4} fontSize={'14px'} color={'#00000099'} lineHeight={'143%'} letterSpacing={'0.17px'}>
                                                Year
                                            </Grid>
                                            <Grid item md={7} fontSize={'16px'} color={'#000000'}>
                                                {data?.vehicle?.year ? data?.vehicle?.year : ' - '}
                                            </Grid>
                                        </Grid>
                                        <Grid container item>
                                            <Grid item xs={4} fontSize={'14px'} color={'#00000099'} lineHeight={'143%'} letterSpacing={'0.17px'}>
                                                Make
                                            </Grid>
                                            <Grid item md={7} fontSize={'16px'} color={'#000000'}>
                                                {data?.vehicle?.vehicleMake?.name ? data?.vehicle?.vehicleMake?.name : ' - '}
                                            </Grid>
                                        </Grid>
                                        <Grid container item>
                                            <Grid item xs={4} fontSize={'14px'} color={'#00000099'} lineHeight={'143%'} letterSpacing={'0.17px'}>
                                                Model
                                            </Grid>
                                            <Grid item md={7} fontSize={'16px'} color={'#000000'}>
                                                {data?.vehicle?.vehicleModel?.name ? data?.vehicle?.vehicleModel?.name : ' - '}
                                            </Grid>
                                        </Grid>
                                        <Grid container item>
                                            <Grid item xs={4} fontSize={'14px'} color={'#00000099'} lineHeight={'143%'} letterSpacing={'0.17px'}>
                                                Trim
                                            </Grid>
                                            <Grid item md={7} fontSize={'16px'} color={'#000000'}>
                                                {data?.vehicle?.vehicleModelTrim?.name ? data?.vehicle?.vehicleModelTrim?.name : ' - '}
                                            </Grid>
                                        </Grid>
                                        <Grid container item>
                                            <Grid item md={4} sm={4} xs={4} fontSize={'14px'} color={'#00000099'} lineHeight={'143%'} letterSpacing={'0.17px'}>
                                                Licence Plate:
                                            </Grid>
                                            <Grid item md={7} fontSize={'16px'} color={'#000000'}>
                                                {data?.vehicle?.licenseNumber ? data?.vehicle?.licenseNumber : ' - '}
                                            </Grid>
                                        </Grid>
                                        <Grid container item>
                                            <Grid item xs={4} fontSize={'14px'} color={'#00000099'} lineHeight={'143%'} letterSpacing={'0.17px'}>
                                                VIN
                                            </Grid>
                                            <Grid item md={7} fontSize={'16px'} color={'#000000'}>
                                                {data?.vehicle?.vin ? data?.vehicle?.vin : ' - '}
                                            </Grid>
                                        </Grid>
                                        <Grid container item>
                                            <Grid item xs={4} fontSize={'14px'} color={'#00000099'} lineHeight={'143%'} letterSpacing={'0.17px'}>
                                                Odometer
                                            </Grid>
                                            <Grid item md={7} fontSize={'16px'} color={'#000000'}>
                                                {data?.vehicle?.odo && data?.vehicle?.odo !== '' ? (
                                                    <>
                                                        {FormatNumberForKm(data?.vehicle?.odo)} {'km'}
                                                        <br></br>
                                                        {'Last Updated:'}
                                                        {moment(data?.vehicle?.odoUpdatedAt).format('MMM D,YYYY')}
                                                    </>
                                                ) : (
                                                    '-'
                                                )}
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <div
                                        style={{
                                            margin: '24px 0',
                                            textAlign: 'end',
                                            textDecoration: 'underline',
                                            textUnderlineOffset: '2px',
                                            textTransform: 'capitalize',
                                            color: '#006CDD',
                                        }}
                                    >
                                        <p
                                            onClick={() => setShowMore(!showMore)}
                                            style={{
                                                cursor: 'pointer',
                                                margin: '0',
                                                letterSpacing: '0.15px',
                                                lineHeight: '175%',
                                                fontWeight: 500,
                                            }}
                                        >
                                            {showMore ? ' Show Less' : 'Show More'}
                                        </p>
                                    </div>
                                    {showMore && (
                                        <div>
                                            <div className="grid-detail-container">
                                                <div className="vehicle-left-side-grid">
                                                    <Typography
                                                        fontSize={'14px'}
                                                        color={'#00000099'}
                                                        lineHeight={'143%'}
                                                        letterSpacing={'0.17px'}
                                                        alignItems={'flex-start'}
                                                    >
                                                        Trim Description
                                                    </Typography>
                                                </div>
                                                <div className="right-side-grid-detail">
                                                    <Typography fontSize={'16px'} lineHeight={'24px'}>
                                                        {data?.vehicle?.vehicleModelTrim ? data?.vehicle?.vehicleModelTrim?.description : ' - '}
                                                    </Typography>
                                                </div>
                                            </div>
                                            <div className="grid-detail-container">
                                                <div className="vehicle-left-side-grid">
                                                    <Typography fontSize={'14px'} color={'#00000099'} lineHeight={'143%'} letterSpacing={'0.17px'}>
                                                        Engine Type
                                                    </Typography>
                                                </div>
                                                <div className="right-side-grid-detail">
                                                    <Typography fontSize={'16px'} lineHeight={'24px'}>
                                                        {data?.vehicle?.vehicleModelTrim ? data?.vehicle?.vehicleModelTrim?.engineType : ' - '}
                                                    </Typography>
                                                </div>
                                            </div>

                                            <div className="grid-detail-container">
                                                <div className="vehicle-left-side-grid">
                                                    <Typography fontSize={'14px'} color={'#00000099'} lineHeight={'143%'} letterSpacing={'0.17px'}>
                                                        Engine Fuel Type
                                                    </Typography>
                                                </div>
                                                <div className="right-side-grid-detail">
                                                    <Typography fontSize={'16px'} lineHeight={'24px'}>
                                                        {data?.vehicle?.vehicleModelTrim ? data?.vehicle?.vehicleModelTrim?.engineFuelType : ' - '}
                                                    </Typography>
                                                </div>
                                            </div>

                                            <div className="grid-detail-container">
                                                <div className="vehicle-left-side-grid">
                                                    <Typography fontSize={'14px'} color={'#00000099'} lineHeight={'143%'} letterSpacing={'0.17px'}>
                                                        Engine Drive Type
                                                    </Typography>
                                                </div>
                                                <div className="right-side-grid-detail">
                                                    <Typography fontSize={'16px'} lineHeight={'24px'}>
                                                        {data?.vehicle?.vehicleModelTrim ? data?.vehicle?.vehicleModelTrim?.engineDriveType : ' - '}
                                                    </Typography>
                                                </div>
                                            </div>

                                            <div className="grid-detail-container">
                                                <div className="vehicle-left-side-grid">
                                                    <Typography fontSize={'14px'} color={'#00000099'} lineHeight={'143%'} letterSpacing={'0.17px'}>
                                                        Engine Transmission
                                                    </Typography>
                                                </div>
                                                <div className="right-side-grid-detail">
                                                    <Typography fontSize={'16px'} lineHeight={'24px'}>
                                                        {data?.vehicle?.vehicleModelTrim ? data?.vehicle?.vehicleModelTrim?.engineTransmission : ' - '}
                                                    </Typography>
                                                </div>
                                            </div>

                                            <div className="grid-detail-container">
                                                <div className="vehicle-left-side-grid">
                                                    <Typography fontSize={'14px'} color={'#00000099'} lineHeight={'143%'} letterSpacing={'0.17px'}>
                                                        Body Type
                                                    </Typography>
                                                </div>
                                                <div className="right-side-grid-detail">
                                                    <Typography fontSize={'16px'} lineHeight={'24px'}>
                                                        {data?.vehicle?.vehicleModelTrim ? data?.vehicle?.vehicleModelTrim?.bodyType : ' - '}
                                                    </Typography>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </CustomTabPanel>
                                <CustomTabPanel
                                    value={value}
                                    index={2}
                                    style={{
                                        overflow: 'auto',
                                        paddingBottom: '16px',
                                    }}
                                >
                                    <Grid container item rowGap={3}>
                                        <Grid container item rowGap={3} style={{ backgroundColor: 'white' }}>
                                            <Grid item xs={6} sm={4} md={4}>
                                                <Typography
                                                    style={{
                                                        fontSize: '14px',
                                                        fontWeight: 400,
                                                        color: '#00000099',
                                                    }}
                                                    variant="title"
                                                >
                                                    {' '}
                                                    Total Services
                                                </Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography style={{ fontSize: '16px', fontWeight: 400 }} variant="title">
                                                    {appointmentServices.length}
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        {filteredData?.length > 0 && (
                                            <>
                                                <Grid container item rowGap={3} style={{ backgroundColor: 'white' }}>
                                                    <Grid item xs={6} sm={4} md={4}>
                                                        <Typography
                                                            style={{
                                                                fontSize: '14px',
                                                                fontWeight: 400,
                                                                color: '#00000099',
                                                            }}
                                                            variant="title"
                                                        >
                                                            {' '}
                                                            Services Added
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item>
                                                        <Typography style={{ fontSize: '16px', fontWeight: 400 }} variant="title">
                                                            {filteredData?.length}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                                <Grid container md={12} display={'flex'} flexDirection={'row'} justifyContent={'space-between'}>
                                                    <Grid item md={6}>
                                                        <Typography style={{ fontSize: '16px', fontWeight: 500 }} variant="title">
                                                            {' '}
                                                            Services Added
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item md={6}>
                                                        <Typography
                                                            style={{
                                                                fontSize: '13px',
                                                                fontWeight: 500,
                                                                // marginLeft: "70px",
                                                                float: 'inline-end',
                                                                lineHeight: '23px',
                                                            }}
                                                            variant="title"
                                                        >
                                                            <Link
                                                                to={`/approval/${data?._id}`}
                                                                style={{
                                                                    color: '#006CDD',
                                                                    textDecoration: 'none',
                                                                }}
                                                            >
                                                                VIEW APPROVAL DETAILS
                                                            </Link>
                                                        </Typography>
                                                    </Grid>
                                                </Grid>

                                                {filteredData?.map((row, index) => {
                                                    return (
                                                        <Grid
                                                            container
                                                            justifyContent={'space-between'}
                                                            item
                                                            rowGap={3}
                                                            // boxShadow={2}
                                                            border={'1px solid rgba(0, 0, 0, 0.23)'}
                                                            padding={'16px'}
                                                            key={index}
                                                            borderRadius={1}
                                                            color={'black'}
                                                        >
                                                            <Grid container justifyContent={'space-between'}>
                                                                <Grid item md={6}>
                                                                    <Chip
                                                                        label={
                                                                            capitalize(row?.approvalStatus) == 'Approved'
                                                                                ? 'Accepted'
                                                                                : capitalize(row?.approvalStatus)
                                                                        }
                                                                        style={{
                                                                            backgroundColor:
                                                                                row?.approvalStatus == 'waiting'
                                                                                    ? '#FFD60A'
                                                                                    : row?.approvalStatus == 'approved'
                                                                                      ? '#30D158'
                                                                                      : row?.approvalStatus == 'declined'
                                                                                        ? '#FF2727'
                                                                                        : '#000000',
                                                                            color: row?.approvalStatus == 'waiting' ? '#000000' : 'white',
                                                                            fontWeight: '500',
                                                                            textTransform: 'capitalize',
                                                                        }}
                                                                    />
                                                                </Grid>

                                                                {row?.pricingType == 'fixed' ? (
                                                                    <Grid item>
                                                                        <Typography
                                                                            style={{
                                                                                fontSize: '14px',
                                                                                fontWeight: 400,
                                                                            }}
                                                                            variant="body1"
                                                                        >
                                                                            {row?.fixedPrice ? '$' + FormatNumberForKm(row?.fixedPrice) : ''}
                                                                        </Typography>
                                                                    </Grid>
                                                                ) : (
                                                                    <Grid item>
                                                                        <Typography
                                                                            style={{
                                                                                fontSize: '14px',
                                                                                fontWeight: 400,
                                                                            }}
                                                                            variant="body1"
                                                                        >
                                                                            ${parseInt(row?.labor?.totalAmount) + parseInt(row?.sumTotalAmount)}
                                                                        </Typography>
                                                                    </Grid>
                                                                )}

                                                                <Grid item md={12}>
                                                                    <Typography
                                                                        style={{
                                                                            fontSize: '14px',
                                                                            fontWeight: 500,
                                                                            marginTop: '5px',
                                                                        }}
                                                                        variant="body1"
                                                                    >
                                                                        {' '}
                                                                        {row?.serviceName}
                                                                    </Typography>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    );
                                                })}
                                            </>
                                        )}

                                        {data?.service?.length > 0 && (
                                            <Grid item md={6}>
                                                <Typography style={{ fontSize: '16px', fontWeight: 500 }} variant="title">
                                                    {' '}
                                                    Scheduled Services
                                                </Typography>
                                            </Grid>
                                        )}

                                        {appointmentServices?.map((item, index) => {
                                            const hasQuestionAnswer = Object.keys(item?.questionAnswer || {}).length > 0;
                                            const hasValidPricing = item?.pricingType !== 'no_price';

                                            return (
                                                <Grid
                                                    bgcolor={'#fff'}
                                                    border={'1px solid #C4C4C4'}
                                                    borderRadius={'4px'}
                                                    color={'black'}
                                                    container
                                                    item
                                                    justifyContent={'space-between'}
                                                    alignItems={'center'}
                                                    padding={'15px'}
                                                    key={index}
                                                >
                                                    <Grid container justifyContent={'space-between'}>
                                                        <Grid
                                                            item
                                                            md={6}
                                                            // style={{ height: !hasValidPricing ? "21px" : "" }}
                                                        >
                                                            <Typography style={{ fontSize: '14px', fontWeight: 500 }} variant="body1">
                                                                {item?.serviceName}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item style={{ height: !hasValidPricing ? '21px' : '' }}>
                                                            <Typography style={{ fontSize: '14px', fontWeight: 400 }} variant="body1">
                                                                {item?.pricingType === 'no_price' && !hasQuestionAnswer ? (
                                                                    <Delete
                                                                        style={{
                                                                            color: '#D32F2F',
                                                                            cursor: 'pointer',
                                                                        }}
                                                                        onClick={() => {
                                                                            if (appointmentServices?.length > 1) {
                                                                                setSelectedServiceId(item?._id);
                                                                                setIsDeleteDialogOpen(true);
                                                                            } else {
                                                                                toast.error('At least one service is required.');
                                                                            }
                                                                        }}
                                                                    />
                                                                ) : item?.pricingType === SHOP_SERVICE_PRICE_TYPES.NO_PRICE ? (
                                                                    'No Price'
                                                                ) : item?.pricingType === SHOP_SERVICE_PRICE_TYPES.STARTING_FROM ? (
                                                                    `Starting from: ${formatCurrency(item.priceMin)}`
                                                                ) : item?.pricingType === SHOP_SERVICE_PRICE_TYPES.FIXED ? (
                                                                    `${formatCurrency(item.fixedPrice)}`
                                                                ) : item?.pricingType === SHOP_SERVICE_PRICE_TYPES.RANGE ? (
                                                                    `Range ${formatCurrency(item.priceMin)} - ${formatCurrency(item.priceMax)}`
                                                                ) : (
                                                                    '-'
                                                                )}
                                                            </Typography>
                                                        </Grid>
                                                        {item?.description && (
                                                            <Grid item xs={12}>
                                                                <Typography
                                                                    style={{
                                                                        fontSize: 14,
                                                                        fontWeight: 400,
                                                                        color: '#646466',
                                                                        lineHeight: '20px',
                                                                        letterSpacing: '0.17px',
                                                                        marginTop: '4px',
                                                                        wordWrap: 'break-word',
                                                                        whiteSpace: 'normal',
                                                                    }}
                                                                    variant="body1"
                                                                >
                                                                    {item?.description}
                                                                </Typography>
                                                            </Grid>
                                                        )}

                                                        {(hasQuestionAnswer || hasValidPricing) && (
                                                            <Divider
                                                                textAlign="center"
                                                                style={{
                                                                    color: '#0000001F',
                                                                    width: '100%',
                                                                    margin: '4px 0',
                                                                }}
                                                            />
                                                        )}

                                                        <Grid item container xs={12} justifyContent={'space-between'} alignItems={'flex-end'}>
                                                            {hasQuestionAnswer ? (
                                                                <>
                                                                    <Grid item xs={10}>
                                                                        <Typography
                                                                            style={{
                                                                                fontSize: '14px',
                                                                                fontWeight: 500,
                                                                            }}
                                                                            variant="body1"
                                                                        >
                                                                            {item?.questionAnswer?.question}
                                                                        </Typography>
                                                                        <Typography
                                                                            style={{
                                                                                fontSize: '14px',
                                                                                fontWeight: 400,
                                                                                marginTop: '4px',
                                                                            }}
                                                                            variant="body1"
                                                                        >
                                                                            {item?.questionAnswer?.answer}
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Delete
                                                                        style={{
                                                                            color: '#D32F2F',
                                                                            cursor: 'pointer',
                                                                        }}
                                                                        onClick={() => {
                                                                            if (appointmentServices?.length > 1) {
                                                                                setSelectedServiceId(item?._id);
                                                                                setIsDeleteDialogOpen(true);
                                                                            } else {
                                                                                toast.error('At least one service is required.');
                                                                            }
                                                                        }}
                                                                    />
                                                                </>
                                                            ) : hasValidPricing ? (
                                                                <Grid xs={12} display={'flex'} justifyContent={'flex-end'}>
                                                                    <Delete
                                                                        style={{
                                                                            color: '#D32F2F',
                                                                            cursor: 'pointer',
                                                                        }}
                                                                        onClick={() => {
                                                                            if (appointmentServices?.length > 1) {
                                                                                setSelectedServiceId(item?._id);
                                                                                setIsDeleteDialogOpen(true);
                                                                            } else {
                                                                                toast.error('At least one service is required.');
                                                                            }
                                                                        }}
                                                                    />
                                                                </Grid>
                                                            ) : null}
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            );
                                        })}

                                        <Grid item xs={12} display={'flex'} justifyContent={'flex-end'}>
                                            <Button startIcon={<Add />} variant="contained" color="primary" onClick={() => setIsAddServiceModalOpen(true)}>
                                                ADD SERVICE
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </CustomTabPanel>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>

            <ShortServiceModal
                loader={isServiceLoader}
                open={isAddServiceModalOpen}
                onClose={() => {
                    setIsAddServiceModalOpen(false);
                }}
                onSave={async (service, obj) => {
                    setIsServiceLoader(true);
                    const resp = await dispatch(addServiceToAppointmentDetailApi(data?._id, { service }));
                    if (resp) {
                        queryClient.invalidateQueries({
                            queryKey: appointmentKeys.details(data?._id),
                            refetchType: 'all',
                        });
                        // let cloneobj = { ...obj };
                        // cloneobj.serviceName = obj.serviceSubCategory.name;
                        // cloneobj.serviceId = obj.serviceSubCategory._id;
                        // cloneobj.pricingType = obj.priceType;

                        // setAppointmentServices((prev) => {
                        //   const isAlreadyAdded = prev.some(
                        //     (item) => item._id === cloneobj._id
                        //   );
                        //   return isAlreadyAdded ? prev : [...prev, cloneobj];
                        // });
                        setIsAddServiceModalOpen(false);
                        recallDetailsAPI();
                    }
                    setIsServiceLoader(false);
                }}
            />
            <CommonDialog
                loader={isServiceLoader}
                open={isDeleteDialogOpen}
                onClose={() => {
                    if (!isServiceLoader) {
                        setIsDeleteDialogOpen(false);
                    }
                }}
                onSave={async () => {
                    setIsServiceLoader(true);
                    const resp = await dispatch(deleteServiceFromAppointmentDetailApi(data?._id, selectedServiceId));
                    if (resp) {
                        queryClient.invalidateQueries({
                            queryKey: appointmentKeys.details(data?._id),
                            refetchType: 'all',
                        });
                        // recallDetailsAPI();
                        setAppointmentServices((prev) => prev.filter((item) => item._id !== selectedServiceId));
                        setSelectedServiceId(null);
                        setIsDeleteDialogOpen(false);
                    }
                    setIsServiceLoader(false);
                }}
                dialogTitle={'Delete service? '}
                dialogSubtitle={'Are you sure you want to delete this service from the appointment?'}
            />
            {/* {(status == "waiting_for_drop_off" || status == "in_progress") && (
        <AddOdoModal
          open={show}
          handleClose={handleStatusClose}
          updateStatus={updateStatus}
          id={data?._id}
          handleClose1={handleClose1}
          currentStatus={status}
          handleClose2={handleClose}
          appointmentView={() => {}}
        />
      )} */}
            <AddAssigneeModal open={showAssignee} handleClose={handleCloseAssigneeModal} data={data} setIsAssigneeChanged={setIsAssigneeChanged} />
            <GuestCustomerInfoModal
                userData={data}
                openGuestModal={openGuestModal}
                setOpenGuestModal={setOpenGuestModal}
                showBtn
                showTag
                fetchAppointmentDetails={fetchAppointmentDetails}
                onCustomerConverted={async (convertedUser) => {
                    if (fetchAppointmentDetails) {
                        await fetchAppointmentDetails();
                    }
                    if (convertedUser?._id) {
                        navigate(`/customers/${convertedUser._id}/${convertedUser?.createdFrom ? convertedUser.createdFrom : 'apex_auto_app'}`);
                    }
                }}
            />
            <SaveCustomerConfirmModal
                open={saveConfirmModal}
                setActionState={setActionState}
                setSaveConfirmModal={setSaveConfirmModal}
                userData={data}
                userName={data?.customer?.firstName + ' ' + data?.customer?.lastName}
                handleClose={async (resp) => {
                    setSaveConfirmModal(false);
                    if (resp !== 'close') {
                        if (actionState.isActionSaved) {
                            if (actionState.authRequest) {
                                navigate(actionState.authRequest);
                            }
                            if (actionState.messageToSend) {
                                navigate(actionState.messageToSend);
                            }
                            if (actionState.requestApproval) {
                                navigate(actionState.requestApproval);
                            }
                            if (actionState.rescheduleAction) {
                                setOpenRescheduleModal();
                            }
                        }
                        await fetchAppointmentDetails();
                    } else {
                        setActionState({
                            isActionSaved: false,
                            messageToSend: null,
                            rescheduleAction: null,
                            authRequest: null,
                            requestApproval: null,
                        });
                    }
                }}
            />

            <ReseduleAppointmentModal
                open={openRescheduleModal}
                handleClose={() => {
                    setOpenRescheduleModal(false);
                }}
                id={data?._id}
                handleClose2={handleClose}
                date={data?.proposedropOffDateTime ? data?.proposedropOffDateTime : data?.dropOffDateTime}
                recallDetailsAPI={() => {
                    recallDetailsAPI();
                }}
                fromCaledner={fromCaledner}
            />

            <ReviewRequestModal
                shopConfigData={shopConfigData}
                open={showReviewModal}
                onClose={() => {
                    setShowReviewModal(false);
                    setReviewModalLastSentOn('');
                }}
                modalTitle={modalTitle}
                customerName={`${data?.customer?.firstName ? data.customer.firstName : ''}${data?.customer?.lastName ? ' ' + data.customer.lastName : ''}`}
                carInfo={`${data?.vehicle?.year ? data.vehicle.year : ''}${data?.vehicle?.vehicleMake?.name ? ' ' + data.vehicle.vehicleMake.name : ''}${
                    data?.vehicle?.vehicleModel?.name ? ' ' + data.vehicle.vehicleModel.name : ''
                }${data?.vehicle?.vehicleModelTrim?.name ? ' ' + data.vehicle.vehicleModelTrim.name : ''}`}
                googleImage={googleImage}
                showInstructionText={showInstructionText}
                googleReviewMessage={reviewModalLastSentOn}
                shopName={SHOP_NAME}
                sendRequest={(queryString, customMessage) => {
                    UpdateStatus(data?._id, 'customer_paid', queryString, customMessage);
                    setShowReviewModal(false);
                    setReviewModalLastSentOn('');
                }}
                onClickSkip={() => {
                    setShowReviewModal(false);
                    setReviewModalLastSentOn('');
                }}
            />

            <CancelAppointment
                open={openCancelModal}
                handleClose={handleCloseCancelModal}
                id={data?._id}
                data={data}
                handleClose2={() => {
                    setOpenCancelModal(false);
                    setIsEditingNote(false);
                    setEditedNote('');
                    handleClose();
                }}
            />

            <Dialog fullScreen={false} open={updateNoteMutation.isPending || showLoader}>
                <DialogContent>
                    <CircularProgress />
                </DialogContent>
            </Dialog>
        </Box>
    );
};

export default AppointmentModel;
